import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavController } from "@ionic/angular";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { LangService } from "../../services/lang.service";
import { UserService } from "../../services/user.service";
import { NotificationsService } from "../../services/notifications.service";

@Component({
    selector: 'app-mobile-header-banner',
    templateUrl: './mobile-header-banner.component.html',
    styleUrls: ['./mobile-header-banner.component.scss'],
    standalone: false
})
export class MobileHeaderBannerComponent implements OnInit, OnDestroy {
    currentUrl: string = '';

    showHomeImages: boolean = false;
    showBackButton: boolean = false;
    unreadCount: number = 0;
    needsAccountDetails: boolean = false;

    /**
     * Badge count shown on the header bell. Includes the virtual
     * "complete your account details" prompt, which is not a stored
     * notification and so is not part of the backend unread count.
     */
    get notificationBadgeCount(): number {
        return this.unreadCount + (this.needsAccountDetails ? 1 : 0);
    }

    private routerSubscription?: Subscription;
    private unreadSubscription?: Subscription;
    private userSubscription?: Subscription;

    private backButtonRoutes: string[] = [
        '/article',
        '/articles',
        '/category',
        '/search',
        '/guides',
        '/account',
        '/add-entry',
        '/calendar',
        '/directory-of-services',
        '/live-incident',
        '/shorts',
        '/crisis-mode',
        '/add-journal',
        '/journal',
        '/notifications'
    ];

    private backButtonRoutePrefixes: string[] = [
        '/guides/',
        '/risk-assesment/',
    ];

    constructor(
        public lang: LangService,
        private navController: NavController,
        private router: Router,
        public userService: UserService,
        private notificationsService: NotificationsService,
    ) {}

    ngOnInit() {
        this.currentUrl = this.router.url;
        this.checkRoute(this.currentUrl);

        // Drive the badge from the shared count so it stays in sync app-wide.
        this.unreadSubscription = this.notificationsService.unreadCount$.subscribe(count => {
            this.unreadCount = count;
        });

        // The virtual "complete your account details" prompt adds +1 to the badge,
        // mirroring the desktop header.
        this.userSubscription = this.userService.data.subscribe((userData: any) => {
            this.needsAccountDetails = !!userData?.needs_account_details;
        });

        this.routerSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: any) => {
                this.currentUrl = event.urlAfterRedirects || event.url;
                this.checkRoute(this.currentUrl);
            });
    }

    goToNotifications() {
        this.navController.navigateForward(['/notifications']);
    }

    private checkRoute(url: string): void {
        const path = url.split('?')[0];

        this.showHomeImages = path === '/home';

        this.showBackButton =
            this.backButtonRoutes.some(route => path === route || path.startsWith(route + '/')) ||
            this.backButtonRoutePrefixes.some(prefix => path.startsWith(prefix));
    }

    goHome() {
        this.navController.navigateRoot(['/home']);
    }

    goBack() {
        this.navController.back();
    }

    ngOnDestroy() {
        this.routerSubscription?.unsubscribe();
        this.unreadSubscription?.unsubscribe();
        this.userSubscription?.unsubscribe();
    }

    goToAccount() {
        let route = this.userService.isLoggedIn ? '/account' : '/login';
        this.navController.navigateRoot([route]);
    }
}
